import { takeEvery, put, delay } from 'redux-saga/effects';
import { addNotification, fetchNotifications } from '../slices/notificationsSlice';

function* onFetchNotifications() {
    try {
        yield delay(500);

        yield put(
            addNotification({
                id: '1',
                title: 'Saga Notification',
                description: 'Loaded from Saga!',
                time: 'just now',
                type: 'message',
            })
        );
    } catch (error) {
        console.log('Error fetching notifications:', error);
    }
}

export function* notificationsSaga() {
    yield takeEvery(fetchNotifications.type, onFetchNotifications);
}